import Vue from 'vue'
import VueRouter from 'vue-router'

import loginApi from '@/api/login.api'
import store from '@/store'
import user from '@/store/modules/user.store'
import routes from './routes'
import Bowser from 'bowser'

Vue.use(VueRouter)

function createRouter () {
  const router = new VueRouter({
    routes: routes(),
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  })

  router.beforeResolve((to, from, next) => {
    if (from.name === 'main.mes-recoltes') {
      store.dispatch('filtresApports/reset')
    }
    if (from.name === 'main.mes-contrats') {
      store.dispatch('filtresContrat/reset')
    }

    if (from.path === '/login-callback-redirect') {
      Vue.$cookies.remove('NUMTIERS_SELECTED')
      Vue.$cookies.remove('ANNEE_RECOLTE_SAVED')
      Vue.$cookies.remove('CODE_GRAINE_SAVED')
      store.dispatch('user/load')
        .then(() => {
          const infoNavigateur = Bowser.getParser(
            window.navigator.userAgent
          ).getResult()

          const loginDetails = {
            username: user.state.profil.username,
            dateLogin: new Date(),
            navigateur: {
              nom: infoNavigateur.browser.name,
              version: infoNavigateur.browser.version
            },
            systemeExploitation: {
              nom: infoNavigateur.os.name,
              version: infoNavigateur.os.version,
              versionName: infoNavigateur.os.versionName
            },
            typePlateforme: infoNavigateur.platform.type,
          }

          loginApi.createLoginDetails(loginDetails).catch((err) => {
            throw err
          })
        })
    }
    // ensemble des permission si non vides (null sinon)
    const listePermissions = to.matched
      .map(route => route.meta && route.meta.permissions ? route.meta.permissions : [])
      .filter(elem => elem.length > 0)

    if (to.matched.some(route => route.meta != null && route.meta.closed)) {
      // Redirige vers la page not-authorize si page fermée
      next({ name: 'unauthorized', query: { redirectFrom: from.name }, replace: true })
    } else if (listePermissions.length > 0) {
      const user = store.getters['user/profil']
      if (user && user.roles && listePermissions.every(permissions => permissions.some(permission => user.roles.includes(permission)))) {
        next()
      } else {
        // Redirige vers la page not-authorize si pas les permissions demandées
        next({ name: 'unauthorized', query: { redirectFrom: from.name }, replace: true })
      }
    } else {
      next()
    }
  })

  router.afterEach(() => {
    store.dispatch('navigation/end')
  })

  router.onError(() => {
    store.dispatch('navigation/end')
  })

  return router
}

export default createRouter
